module.exports = __webpack_public_path__ + "static/media/Robotomedium.38aa81d4.ttf";